import { Injectable } from '@angular/core';
import { AngularFireMessaging } from "@angular/fire/compat/messaging";
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FirebasemessagingService {

  currentMessage = new BehaviorSubject<any>(null);
  fcmToken = new BehaviorSubject<string | null>(null);

  constructor(private afMessaging: AngularFireMessaging) { }

  requestPermission() {
    this.afMessaging.requestPermission
      .subscribe(
        () => {
          this.afMessaging.getToken.subscribe(
            (token) => {
              console.log('FCM Token:', token);
              localStorage.setItem("FCMToken" , token);
              this.fcmToken.next(token)
            },
            (error) => console.error('Error getting token', error)
          );
        },
        (error) => console.error('Permission denied', error)
      );
  }

  getFcmToken(){
    return this.fcmToken.asObservable()
  }

  listenForMessages() {
    this.afMessaging.messages
      .subscribe((payload: any) => {
        console.log('Message received:', payload);
        this.currentMessage.next(payload);
      });
  }

}
